import { useState } from "react"
import "./mui.css"
import css from "./EditListingLocationForm.module.css"

export default function Counter(props) {
  const {
    count,
    setCount
  } = props

  const handleClick = () => {
    if (count > 1)  {
      const newCount = count - 1
      return setCount(newCount)
    }
  }


  return (
    <div className={css.counter}>
      {
       (count < 2) ? 
       <button type="button" className={css.buttonDisabled}>-</button>
       :
       <button type="button" className={css.button} onClick={handleClick}>-</button>
      }
      <span className={css.span}>{count}</span>  
      <button type="button" className={css.button} onClick={() => setCount(count + 1)}>+</button>
    </div>
  );
}